import React from 'react';
import { useDomain } from '@/contexts/DomainContext';

interface SEOProps {
  title: string;
  description?: string;
  ogImage?: string;
  canonicalPath?: string;
}

const SEO: React.FC<SEOProps> = ({ title, description, ogImage, canonicalPath }) => {
  const { currentDomain } = useDomain();

  React.useEffect(() => {
    document.title = title;
    if (description) {
      let descTag = document.querySelector('meta[name="description"]');
      if (!descTag) {
        descTag = document.createElement('meta');
        descTag.setAttribute('name', 'description');
        document.head.appendChild(descTag);
      }
      descTag.setAttribute('content', description);
    }
    if (ogImage) {
      let ogTag = document.querySelector('meta[property="og:image"]');
      if (!ogTag) {
        ogTag = document.createElement('meta');
        ogTag.setAttribute('property', 'og:image');
        document.head.appendChild(ogTag);
      }
      ogTag.setAttribute('content', ogImage);
    }
    if (canonicalPath) {
      const canonicalUrl = `https://${currentDomain}${canonicalPath}`;
      let canonicalTag = document.querySelector('link[rel="canonical"]');
      if (!canonicalTag) {
        canonicalTag = document.createElement('link');
        canonicalTag.setAttribute('rel', 'canonical');
        document.head.appendChild(canonicalTag);
      }
      canonicalTag.setAttribute('href', canonicalUrl);

      let ogUrlTag = document.querySelector('meta[property="og:url"]');
      if (!ogUrlTag) {
        ogUrlTag = document.createElement('meta');
        ogUrlTag.setAttribute('property', 'og:url');
        document.head.appendChild(ogUrlTag);
      }
      ogUrlTag.setAttribute('content', canonicalUrl);
    }
  }, [title, description, ogImage, canonicalPath, currentDomain]);

  return null;
};

export default SEO; 